<template>
    <q-icon
        v-if="services.length"
        :name="icon"
        size="xs"
        :color="color"
        class="cursor-pointer"
    >
        <q-tooltip>
            <div class="q-pa-sm text-left">
                <h6 class="q-mb-sm">
                    {{ $t('courses.services_included_in_course') }}
                </h6>
                <div v-for="service in services" :key="service.id">
                    &#x2022;
                    <span class="text-body2">
                        {{ `${service.services.name}` }} ({{
                            $t('general.quantity')
                        }}: {{ service.quantity }})
                    </span>
                </div>
            </div>
        </q-tooltip>
    </q-icon>
</template>

<script>
import coursesService from '@/services/modules/coursesServices'

const loadingKeys = {
    fetchingServices: 'fetching-services',
}

export default {
    name: 'ServicesInCourseBadgeComponent',

    props: {
        courseId: {
            type: Number,
            required: true,
        },

        color: {
            type: String,
            default: 'blue',
        },

        icon: {
            type: String,
            default: 'fa fa-info-circle',
        },
    },

    data() {
        return {
            services: [],
        }
    },

    async created() {
        await this.fetchServices()
    },

    methods: {
        // fetch course services
        async fetchServices() {
            this.loadingAdd(loadingKeys.fetchingServices)

            let parameters = {
                method: 'retrieve',
                filter: {
                    courseId: this.courseId,
                },
                relations: {
                    services: true,
                },
            }
            let response = await coursesService.retrieve(parameters)

            this.loadingRemove(loadingKeys.fetchingServices)

            if (response.status !== 200) {
                this.notifyError(response)
                return
            }

            this.services = response.data.results
        },
    },
}
</script>
